import { IApiServiceContext, ApiServiceContextState } from '../context/ApiServiceContext';
import { useContext } from 'react';
import {ISettingsContext, SettingsContextState} from "../context/SettingsContext";

export const useSettings = () => useContext<SettingsContextState>(ISettingsContext)